import type { ComponentPropsWithoutRef } from 'react'

const CheckBoxInputSet = ({ className = '', ...props }: ComponentPropsWithoutRef<'li'>) => <li className={`relative py-2 ${className}`} {...props} />

export default CheckBoxInputSet
